// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 查询目录列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /course/catalog/list */
export async function courseCatalogListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.courseCatalogListUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultListCourseCatalogResp>("/course/catalog/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 编辑浏览量 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /course/catalog/updateVisitCount */
export async function courseCatalogUpdateVisitCountUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.courseCatalogUpdateVisitCountUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultstring>("/course/catalog/updateVisitCount", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
